import { render, staticRenderFns } from "./TablePrompter.vue?vue&type=template&id=f203c75a&scoped=true"
import script from "./TablePrompter.vue?vue&type=script&lang=js"
export * from "./TablePrompter.vue?vue&type=script&lang=js"
import style0 from "./TablePrompter.vue?vue&type=style&index=0&id=f203c75a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f203c75a",
  null
  
)

export default component.exports